import { useMemo, useState } from 'react'
import SelectMui from 'components/forms/SelectMui'
import Info from 'components/Info'
import { InfoRedStyle, Row, ValidButton } from '../ProductListTable.definitionFields'
import { ProductCreation, productUnits, Unit } from '@Arti-zen/package-backoffice'

type TProps = {
  currentUnit: string
  errorMessage: string
  correctProduct: (corrections: Partial<ProductCreation>) => void
}

export default function UnitProductErrorTable({ currentUnit, correctProduct, errorMessage }: TProps) {
  const [unit, setUnit] = useState<Unit | string>(currentUnit)

  const units = useMemo(
    () => [
      { label: <div style={{ color: 'red' }}>{currentUnit}</div>, value: currentUnit },
      ...productUnits.map((u) => {
        return { label: u, value: u }
      }),
      { label: 'Aucun', value: null },
    ],
    [productUnits]
  )

  const updateUnit = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctProduct({ unit })
  }

  return (
    <Row style={{ gap: 5 }}>
      <SelectMui onChange={(unit) => setUnit(unit)} value={unit} items={units} />
      {unit !== currentUnit && <ValidButton onClick={updateUnit}>OK</ValidButton>}
      <Info text={errorMessage} style={InfoRedStyle} />
    </Row>
  )
}
